const micrositesParams = ["percentile-wage"];

const paramRules = {
	"/archive/labor-cost": micrositesParams,
	"/archive/labor-supply": micrositesParams,
};

export default paramRules;
